import { FilterOption, FilterParams } from '@/plp/components/PlpFilters/PlpFilters.type';
import { updateCurrentFilterOptions } from '@/plp/components/PlpFilters/plpFilterOptions.helper';
import { mapFilterParamsToFormattedFilters } from '@/plp/components/PlpFilters/plpFiltersMap';
import { isPlpNoFollow } from '@/plp/helpers/isPlpNoFollow';
import { FilterValues } from '@/types/CataloguePage.types';

import { getPlpPath } from './getPlpPath';

export const filterOrder: FilterValues[] = [
  FilterValues.Keyword,
  FilterValues.State,
  FilterValues.Transmission,
  FilterValues.Make,
  FilterValues.Model,
  FilterValues.FuelCategory,
  FilterValues.FuelSubType,
  FilterValues.BodyType,
  FilterValues.BodySize,
  FilterValues.CashMin,
  FilterValues.CashMax,
  FilterValues.FinanceMin,
  FilterValues.FinanceMax,
  FilterValues.YearMin,
  FilterValues.YearMax,
  FilterValues.KMMin,
  FilterValues.KMMax,
  FilterValues.HighlightedFeatures,
  FilterValues.DriveType,
  FilterValues.Seats,
  FilterValues.Doors,
  FilterValues.Colour,
  FilterValues.Ancap,
  FilterValues.Co2emissions,
  FilterValues.TowCapBrakedMin,
  FilterValues.TowCapBrakedMax,
];

type Props = {
  params: FilterParams;
  filterOption: FilterOption;
  filtersMap: Map<string, FilterOption>;
  childFilter?: FilterValues;
  parentFilter?: FilterValues;
};

export const getPlpUrl = ({ params, filterOption, filtersMap }: Props): { href: string; nofollow: boolean } => {
  const currentFilters = mapFilterParamsToFormattedFilters(params.filter, filtersMap);
  const updatedFilters = updateCurrentFilterOptions(currentFilters, filterOption);
  const filterParam = getFilterParamFromCurrentFilters(updatedFilters);
  const href = getPlpPath(filterParam, params.sort, params.page);
  const nofollow = isPlpNoFollow(filterParam);

  return {
    href,
    nofollow,
  };
};

export const getPlpUrlWithAvailableFilter = (params: FilterParams) => {
  if (params.filter.includes('available') || params.filter.includes('available_')) {
    const updatedSlug = params.filter.replaceAll('available_', '').replaceAll('available', '');
    return getPlpPath(updatedSlug, params.sort);
  }
  const filterPart = params.filter ? `_${params.filter}` : '';
  return getPlpPath(`available${filterPart}`, params.sort);
};

export const getFilterParamFromCurrentFilters = (currentFilters: FilterOption[]): string => {
  const groupedFilterTypeAndSlugMap = currentFilters.reduce((acc, item) => {
    const existingSlugs = acc.get(item.filter) || [];
    const combinedSlugs = [...existingSlugs, item.slug];
    combinedSlugs.sort((a, b) => a.localeCompare(b));
    acc.set(item.filter, combinedSlugs);
    return acc;
  }, new Map<FilterValues, string[]>());

  const orderedSlugs = [
    ...new Set(
      filterOrder
        .map((filterValue) => {
          const slugs = groupedFilterTypeAndSlugMap.get(filterValue) || [];
          return [...new Set(slugs)].join('_');
        })
        .filter((item) => item.length),
    ),
  ];

  return orderedSlugs.join('_');
};
